const counter = () => {

	const numbers = document.querySelector('.numbers-wrapper')

	const observer = new IntersectionObserver(function (entries) {
		if (entries[0].isIntersecting === true) {
			document.querySelectorAll('[data-counter]').forEach(counter)
		}
	}, { threshold: [0] })
	if (numbers !== null) {
		observer.observe(numbers)
	}

	const counter = (EL) => {
		const duration = 2000 // Animate all counters equally for a better UX
		const start = 0
		const end = parseFloat(EL.dataset.counter)
		if (start === end) return // If equal values, stop here.
		const range = end - start // Get the range
		let curr = start // Set current at start position
		const timeStart = Date.now()
		const loop = () => {
			let elaps = Date.now() - timeStart
			const options = { minimumFractionDigits: 0, maximumFractionDigits: 0 }
			if (elaps > duration) elaps = duration // Stop the loop
			const frac = elaps / duration // Get the time fraction
			const step = frac * range // Calculate the value step
			curr = start + step // Increment or Decrement current value
			EL.textContent = curr.toLocaleString('be-NL', options)
			if (elaps < duration) requestAnimationFrame(loop) // Loop
		}
		requestAnimationFrame(loop) // Start the loop!
	}
}

export default counter;
